module.exports = __webpack_public_path__ + "img/image.7ae986bb.svg";